"use strict";

/**
 * @classdesc
 * Aktion zum Auflösen eines Gruppenlayers.
 *
 * @class
 * @extents gc.gis.action.GCAbstractAction
 * @memberof gc.gis
 * @author Anton Popov <a.popov@brain-scc.de>
 */
gc.gis.action.layer.FitExtent = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	this.func = this.doFitExtent;
	this.args = [options.layer];
};
gc.gis.action.layer.FitExtent.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

gc.gis.action.layer.FitExtent.prototype.doFitExtent = function( layer )
{
	layer.getExtent( function( result ) {
		if (result.extent && result.extent[0] && result.extent[1] && result.extent[2] && result.extent[3]) {
            gc.gis.iface.map.fitExtent(result.extent, {
                projection: gc.gis.iface.map.getProjection()
        	});
        }
        else {
            gc.gis.iface.log.info(this, 'Ausdehnung für Ebene "' + layer.getLabel() + '" konnte nicht ermittelt werden.');
		}
	});
};

